import { render } from "./RedirectModal.vue?vue&type=template&id=5de22557&ts=true"
import script from "./RedirectModal.vue?vue&type=script&lang=ts"
export * from "./RedirectModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__